import { AbstractControl, ValidationErrors } from '@angular/forms';

export class FormUtils {
  constructor() {}

  public static trueFalseNullValidator(
    control: AbstractControl
  ): ValidationErrors | null {
    const value = control.value;
    if (value === true || value === false || value === null) {
      return null; // valid
    }
    return { invalidValue: 'Value must be true, false, or null' }; // invalid
  }

  public static evaluateTrueFalseNullableOption(value: number) {
    return value === 1 ? true : value === 0 ? false : null;
  }

  public static evaluateResponseTextByType(
    questionType: string,
    value: string | boolean
  ) {
    if (questionType == 'B') {
      if (
        value == 'true' ||
        value == 'false' ||
        value === true ||
        value === false
      ) {
        return null;
      } else if (value != null && value != undefined) {
        return value.toString();
      } else {
        return null;
      }
    } else if (questionType == 'T') {
      return value.toString();
    } else if (questionType == 'R') {
      if (value == '0') {
        return "N";
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public static evaluateResponseBooleanByType(
    questionType: string,
    value: string | boolean
  ) {
    if (questionType == 'B') {
      if (value === true || value === false) {
        return value;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}
